import React, { useState, useCallback } from 'react';
import EDIconButton from '../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import LeverantorFakturaModal from './LeverantorFakturaModal';

interface IProps {
  id: string;
  disabled?: boolean;
  hidden?: boolean;
}

const LeverantorFakturaBildIkon: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const [open, setOpen] = useState(false);

  const onClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      setOpen(!open);
    },
    [open]
  );

  return !props.hidden ? (
    <>
      <EDIconButton
        onClick={onClick}
        icon="image_search"
        tooltip="Fakturabild"
        margin="dense"
        padding="dense"
        disabled={props.disabled}
      />
      {open && (
        <LeverantorFakturaModal
          id={props.id}
          onClose={() => setOpen(false)}
          open={open}
        />
      )}
    </>
  ) : (
    <></>
  );
};

export default LeverantorFakturaBildIkon;
